<div id="wrapperDiv" [ngClass]="{'small-wrapper': !isFullScreen, 'large-wrapper': isFullScreen}">
  <ejs-imageeditor #imageEditor (fileOpened)="onFileOpened($event)"
                    (created)="created()" (toolbarItemClicked)="onToolbarItemClicked($event)" width='100%' height='100%'>
  </ejs-imageeditor>
</div>
